import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.dems_user_assigned_uid !== model.dems_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.dems_user_modified_uid,
						assignedTo: modifiedModel.dems_user_assigned_uid,
						title: 'Nuovo DEM assegnato',
						body: `${model.user_modified_title} ti ha assegnato a "${model.dems_title}".`,
						url: `${window.location.origin}/dems/details/${model.dems_uid}`,
						icon: 'email-multiple-outline',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
